import PropTypes from 'prop-types';
import InnerFormSection from 'components/ui-components/forms/InnerFormSection';
import HookFormRadioContainer from 'components/cef_form/hook-form/HookFormRadioContainer';
import HookFormPostcodeSelector from 'components/cef_form/hook-form/HookFormPostcodeSelector';
import { compareAddresses } from 'components/cef_form/PostcodeSelector/postcodeSelectorUtils';

const BillingAddressSelector = ({
  showPostcodeSelector,
  postcodeSearched,
  setPostcodeSearched,
  setPostcodeIsReset,
  newAddressDataModel,
  persistedData,
}) => {
  const billingRadioItems = [
    {
      id: 'yes',
      label: 'Yes',
      value: true,
    },
    {
      id: 'no',
      label: 'No',
      value: false,
    },
  ];

  const { addressOne, addressTwo } = persistedData;

  const addressesAreIdentical = compareAddresses(addressOne, addressTwo);

  return (
    <InnerFormSection title="Billing Address">
      <HookFormRadioContainer
        direction="horizontal"
        id="billingAddressMatchesRegistered"
        label="Is your billing address the same as your registered address?"
        radioItems={billingRadioItems}
      />

      {showPostcodeSelector && (
        <HookFormPostcodeSelector
          className="mt-20"
          id="billing"
          postcodeSearched={postcodeSearched}
          setPostcodeSearched={setPostcodeSearched}
          setPostcodeIsReset={setPostcodeIsReset}
          addressDataModel={newAddressDataModel}
          // Don't persist data if address 1 & 2 match
          // Because if the user comes back to see the persisted data, if they then check 'No' on
          // the 'Is billing same as Registered' radio group, we want the address fields to be
          // clear, not to have the duplicated address populating them
          persistedData={addressesAreIdentical ? undefined : addressTwo}
        />
      )}
    </InnerFormSection>
  );
};

BillingAddressSelector.propTypes = {
  showPostcodeSelector: PropTypes.bool.isRequired,
  postcodeSearched: PropTypes.bool.isRequired,
  setPostcodeSearched: PropTypes.func.isRequired,
  setPostcodeIsReset: PropTypes.func.isRequired,
  newAddressDataModel: PropTypes.shape({
    'addresses.2.house_number': PropTypes.string,
    'addresses.2.address_line_1': PropTypes.string,
    'addresses.2.address_line_2': PropTypes.string,
    'addresses.2.address_line_3': PropTypes.string,
    'addresses.2.address_line_4': PropTypes.string,
    'addresses.2.postcode': PropTypes.string,
  }),
  persistedData: PropTypes.shape({
    addressOne: PropTypes.shape({
      house_number: PropTypes.string,
      address_line_1: PropTypes.string,
      address_line_2: PropTypes.string,
      address_line_3: PropTypes.string,
      address_line_4: PropTypes.string,
      postcode: PropTypes.string,
    }),
    addressTwo: PropTypes.shape({
      house_number: PropTypes.string,
      address_line_1: PropTypes.string,
      address_line_2: PropTypes.string,
      address_line_3: PropTypes.string,
      address_line_4: PropTypes.string,
      postcode: PropTypes.string,
    }),
  }),
};

export default BillingAddressSelector;
